<div class="header">
  <strong>ATENDENTE</strong>
  <strong>DATA DO ATENDIMENTO</strong>
  <strong>CATEGORIA</strong>
  <strong>PALAVRA CHAVE</strong>
  <strong>QUANTIDADE</strong>
</div>
